import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import StepItem from 'components/StepItem/StepItem';
import TitleTableWrapper from 'components/TitleTableWrapper/TitleTableWrapper';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';
import { DATA_SETS_CUSTOMERS_STAKEHOLDERS_HEAD_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';

import CreateCustomerModal from './components/CreateCustomerModal/CreateCustomerModal';
import CustomerListModal from './components/CustomerListModal/CustomerListModal';
import CustomersTable from './components/CustomersTable/CustomersTable';

import type IMaterialityAssessmentCustomer from './interfaces/IMaterialityAssessmentCustomer';

import styles from './scss/MaterialityAssessmentSupplier.module.scss';

function MaterialityAssessmentCustomerView({
  isEmptyList, loading, goToNextMaterialityAssessment, goBack, addStakeholder,
  isOpenModal, addCustomer, closeModal, onOpenCreateModal, isCreateModalOpen,
  selectedItems, setSelectedItems,
  vcCustomers, onDeleteItem, hasMore, loadMoreCustomers, listCustomers,
  isEmptyMainList, naceCodeTreeData, search, onSearchChange, setUnSelectedItems,
  vcmName, vcmId, loadMoreVCCustomers, hasMoreVCCustomers, isViewOnly = false,
}:IMaterialityAssessmentCustomer) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={styles.header}>{t('materialityAssessment.titleStakeholder', { vcmName })}</span>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleWrapper
            description={t('materialityAssessment.titleStakeholderDescription')}
          />

          <div className={styles.stepStakeholder}>
            <StepItem title={t('materialityAssessment.titleStepStakeholder')} step={1} done />
            <ArrowRightIcon />
            <StepItem title={t('materialityAssessment.titleSecondStepStakeholder')} step={2} />
          </div>

          <TitleTableWrapper
            title={t('materialityAssessment.importantCustomers')}
            buttonTitle={t('materialityAssessment.addCustomer')}
            onButtonClick={addStakeholder}
            buttonClassName={styles.button}
            showButton={!isEmptyMainList && !isViewOnly}
            prevTitleBtn={t('materialityAssessment.createNewCustomer')}
            onBtnClickPrev={onOpenCreateModal}
          />
          <div className={styles.contentWrapper}>
            {isEmptyMainList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyCustomerDescription')}
                buttonTitle={t('materialityAssessment.addStakeholder')}
                buttonOnClick={addStakeholder}
                disabledButton={isViewOnly}
              />
            ) : (
              <div className={styles.tableWrapper}>
                <CustomersTable
                  items={listCustomers}
                  headerCells={DATA_SETS_CUSTOMERS_STAKEHOLDERS_HEAD_CELLS}
                  onDeleteItem={onDeleteItem}
                  loadMoreCustomers={loadMoreCustomers}
                  hasMore={hasMore}
                  naceCodeTreeData={naceCodeTreeData}
                  isActionsVisible={!isViewOnly}
                  isInfoTable
                />
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={goBack}
          />
          <Button
            title={t('common.next')}
            onClick={goToNextMaterialityAssessment}
            className={styles.button}
          />
        </div>
      </div>
      <CustomerListModal
        open={isOpenModal}
        onClose={closeModal}
        title={t('materialityAssessment.selectImportantCustomers')}
        onConfirm={addCustomer}
        isLoading={loading}
        isEmptyList={isEmptyList}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        vcCustomers={vcCustomers}
        search={search}
        onSearchChange={onSearchChange}
        setUnSelectedItems={setUnSelectedItems}
        loadMoreVCCustomers={loadMoreVCCustomers}
        hasMoreVCCustomers={hasMoreVCCustomers}
      />

      <CreateCustomerModal
        open={isCreateModalOpen}
        onClose={onOpenCreateModal}
        title={t('materialityAssessment.createNewImportantCustomer')}
        vcmId={vcmId}
      />
    </div>
  );
}

export default MaterialityAssessmentCustomerView;
